define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/image/_base",
	"csi/locale",
	"./RefImage"
], function(declare, csiHeading, csiImage, locale, RefImage) {

	return declare(RefImage, {
		bBaseRenderer: true,
		bCopy: false,

		// Boolean: indicates whether or not to traverse path on client rather than server
		// NOTE: be warned that using the server can cause image caching issues since the URL will not change if anything along the path changes
		bClientPath: false,

		// String: path to image from node
		pathImage: null,

		toTooltip: function(/*Context*/ctx, /*Heading*/h, /*Tooltip*/tooltip) {
			// summary: render name of containing node rather than name of image
			// TODO?
		},

		/**
		 * Return referenced image node if it is in cache - it may not be since we are using GetFromNode request
		 * @param {Context} ctx 
		 * @param {Heading} h 
		 * @return {C8Node}
		 */
		_getImageNode(ctx, h) {
			return ctx.cache.getPathNode(ctx.getNode(), csiImage.getDefaultImagePath(this.pathImage));
		},

		_getImageSrc: function(/*Context*/ctx, /*Heading*/h, /*String*/idImage) {
			// summary: render default image for node
			var node = ctx.getNode();
			var path = this.pathImage;

			if (this.bClientPath) {
				node = ctx.cache.getPathNode(node, path);
				path = null;
			}

			return csiImage.getImageSrc(node, path, idImage);
		},

		_onImageLoad: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/img) {
			// summary: mark with heading information to support tooltip
			this.inherited(arguments);
			csiHeading.markHeadingNode(img, h, ctx);
			img.title = locale.getNodeConfiguredName(ctx.getNode(), ctx.cache);

			// stops popup on tab if its an image
			csiHeading.disableHeadingTabStop(img);
		}
	});
});